module.exports = __webpack_public_path__ + "static/media/product (4).5522aa44.jpg";